<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">绑定手机号码</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container>
        <div v-if="loading" style="padding-top:7rem;"><LoadingText /></div>
        <div v-else style="width:95%;margin:auto;padding-top:1rem;">
          <div>
            <div style="margin-top:0.6rem;">
              <div style="width:100px;height:100px;margin:auto;">
                <v-img src="/res/mobile.png" style="width:120%;height:120%;" />
              </div>
            </div>
            <div style="text-align:center;margin-top:2.6rem;">
              <span style="font-size:14px;">绑定的手机号码：</span>
              <span style="font-size:20px;">{{tel}}</span>
            </div>
            <!-- <div style="text-align:center;margin-top:2rem;">
              <v-btn style="width:80%;" color="success" @click="changeBind" large outlined>更换手机号码</v-btn>
            </div> -->
            <div style="text-align:center;margin-top:1.5rem;">
              <v-btn style="width:80%;" color="primary" @click="changeLoginPass" large outlined>修改登录密码</v-btn>
            </div>
            <!-- <div style="margin:auto;padding-top:4rem;width:80%;font-size:0.85rem;color:#616161;">
              <div>提示</div>
              <div style="text-align:center;">电脑端地址：http://ops.gz7x24.cn</div>
            </div> -->
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
export default {
  components: { LoadingText },
  props: {
  },
  data() {
    return {
      tel: '',
      loading: true
    }
  },
  computed: {
  },
  mounted() {
    this.init()
  },
  destroyed() {
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    // 初始化
    async init() {
      var that = this
      that.loading = true
      var res = await that.$api.bz.getUserProfile()
      // console.log('getUserProfile.res', res);
      if (!res.success) {
        console.log('获取绑定手机号码失败', res);
        return
      }
      var data = res.data
      that.tel = data.tel;
      that.loading = false
    },
    // 更换手机号码
    changeBind() {
      var that = this
      that.$router.goPage({ path: '/BindTel' })
    },
    // 修改登录密码
    changeLoginPass() {
      var that = this
      that.$router.goPage({ path: '/ChangeLoginPass' })
    }
  }
}
</script>

<style scoped>
.us_icon_btn {
  position: absolute;
  right: 0px;
  top: 11px;
  /* min-width: 138px !important; */
}
.us_v_text /deep/ .v-label{
  font-size: 0.9rem;
}
.us_v_text /deep/ .v-label--active{
  font-size: 1.03rem !important;
}
.us_no_captcha /deep/ ._nc .stage1{
  height: 35px !important;
  width: 100%;
  padding: 0;
}
.us_no_captcha /deep/._nc .stage1 .slider{
  height: 35px;
}
.us_no_captcha /deep/ ._nc .stage1 .label{
  line-height: 35px;
  height: 35px;
  font-size: 14px;
}
.us_no_captcha /deep/ ._nc .stage1 .button{
  width: 35px;
  height: 35px;
}
.us_no_captcha /deep/ ._nc .stage1 .icon {
  position: absolute;
  left: 5px;
  top: 3px;
}
.us_no_captcha /deep/ ._nc .icon-slide-arrow {
  font-size: 25px;
  color: #dbdbdb;
}
.us_no_captcha /deep/ ._nc .stage1 .track div{
  width: 35px;
  height: 35px;
}
</style>
